import { graphql } from "gatsby"
import React from "react"
import {
  newsletterMain,
  newsLetter,
  newsletterForm,
} from "./newsletter.module.css"
import { Helmet } from "react-helmet"
import get from "lodash/get"


/* Components */
import Layout from "../../components/layout"
import Seo from "../../components/seo/seo"
import Header from "../../components/header/header"
import Footer from "../../components/footer/footer"
import HubSpotForm from "../../components/hubspot-form/hubspot-form"

class NewsletterTemplate extends React.Component {
  render() {
    const desks = get(this.props, "pageContext.desks")

    return (
      <Layout>
        <Helmet>
          <link
            rel="canonical"
            href="https://www.mkbservicedesk.nl/nieuwsbrief/"
          />
        </Helmet>
        <Header desks={desks} />
        <main className={newsletterMain}>
          <div className="container">
            <Seo title="Nieuwsbrief" />
            <div className={newsLetter}>
              <h1>Elke week tips en inspiratie in je inbox!</h1>
              <div className={newsletterForm}>
                <div className={"form-newsletter"}>
                  <p>Schrijf je in voor onze nieuwsbrief en ontvang elke week een
                    mail met praktische informatie die je bedrijf écht vooruit
                    helpt.
                  </p>

                  <HubSpotForm formId="1f0705a4-9d0f-4a81-a130-a31651b9b0a4" />

                </div>
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </Layout>
    )
  }
}

export default NewsletterTemplate

export const pageQuery = graphql`
  query newsletterQuery {
    site {
      siteMetadata {
        title
      }
    }

  }
`
